module.exports = __webpack_public_path__ + "05_mole.0bc139de.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer2/05_mole.png
// module id = yHAI
// module chunks = 0